"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkAndThrowHelperResult = void 0;
// HelperResult[T] is:
// {
//     data: T,
//     success: Boolean,
//     error: { Message: String },
// }

// HelperResult[T] -> T
var checkAndThrowHelperResult = exports.checkAndThrowHelperResult = function checkAndThrowHelperResult(_ref) {
  var data = _ref.data,
    success = _ref.success,
    error = _ref.error;
  if (!success) {
    throw new Error((error === null || error === void 0 ? void 0 : error.Message) || 'Unspecified error');
  }
  return data;
};